export enum AdditionalProductType
{
  FRAME_2023 = 'frame-2023',
  FRAME = 'frame',
  FRAME_PLASTIC = 'frame-plastic',
  GLUE = 'glue',
  ROLL = 'roll',
}

export function isSupportedAdditionalProductType(type: string): boolean
{
  return Object.values<string>(AdditionalProductType).includes(type);
}
